import * as React from 'react';
import {CONST, getQueryStringParams, SearchInput, SearchSelect} from "../../common";
import { QuestionnaireRoles } from './Data';

interface IState {
  form: {
    like: {
      search: string,
    },
    equal: {
      age_group_id: number,
      sport_id: number,
      status: number,
      role_id: number,
      club_id: number
    }
  },
 }

export default class Filters extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({form:  {
        like: {
          search: old_data ? old_data.like.search : '',
        },
        equal: {
          age_group_id: old_data ? old_data.equal.age_group_id : '',
          sport_id: old_data ? old_data.equal.sport_id : '',
          status: old_data ? old_data.equal.status : '',
          role_id: old_data ? old_data.equal.role_id : '',
          club_id: old_data ? old_data.equal.club_id : '',
        }
      }})
  }

  handleInputForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name.split(".");
    let newAccess: any = Object.assign({}, this.state.form);
    newAccess[name[1]][name[2]] = e.target.value;
    this.setState({form: newAccess},() =>  this.props.getResults(this.state.form));
  }

  render(){
    const {age, sports, clubs} = this.props;
    return (
      <div className="row align-items-center">
        <SearchInput name={'form.like.search'} value={this.state.form.like.search} onChange={this.handleInputForm} placeholder={'Search Questionnaires..'} />
        <SearchSelect name={'form.equal.role_id'} value={this.state.form.equal.role_id}  onChange={this.handleInputForm} options={[{"label": "Select Role", "value": ""}, ...QuestionnaireRoles]}/>
        <SearchSelect name={'form.equal.club_id'} value={this.state.form.equal.club_id}  onChange={this.handleInputForm} options={clubs}/>
        <SearchSelect name={'form.equal.age_group_id'} value={this.state.form.equal.age_group_id}  onChange={this.handleInputForm} options={age}/>
        <SearchSelect name={'form.equal.sport_id'} value={this.state.form.equal.sport_id}  onChange={this.handleInputForm} options={sports}/>
        <SearchSelect name={'form.equal.status'} value={this.state.form.equal.status}  onChange={this.handleInputForm} options={CONST.status}/>
      </div>
    )
  }
}